import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["repsWrapper", "personsWrapper", "repsRowsField", "personsRowsField", "repsRow", "personsRow"]

  connect() {
    this.element.addEventListener("architect:serialize", () => this._serialize())
  }

  addRepsRow() {
    this.repsWrapperTarget.insertAdjacentHTML("beforeend", this._repsRowTemplate())
  }

  addPersonsRow() {
    this.personsWrapperTarget.insertAdjacentHTML("beforeend", this._personsRowTemplate())
  }

  removeRow(event) {
    const row = event.target.closest("[data-architect-form-target]")
    if (row) row.remove()
  }

  _serialize() {
    const reps = Array.from(this.repsWrapperTarget.querySelectorAll("[data-architect-form-target='repsRow']")).map(row => ({
      field1: row.querySelector("[data-field='field1']")?.value || "",
      field2: row.querySelector("[data-field='field2']")?.value || "",
      field3: row.querySelector("[data-field='field3']")?.value || ""
    }))

    const persons = Array.from(this.personsWrapperTarget.querySelectorAll("[data-architect-form-target='personsRow']")).map(row => ({
      field1: row.querySelector("[data-field='field1']")?.value || "",
      field2: row.querySelector("[data-field='field2']")?.value || ""
    }))

    this.repsRowsFieldTarget.value = JSON.stringify(reps)
    this.personsRowsFieldTarget.value = JSON.stringify(persons)
  }

  _repsRowTemplate() {
    return `
      <div class="flex items-center gap-2 group" data-architect-form-target="repsRow">
        <input type="text" placeholder="Title" data-field="field1"
               class="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
        <input type="text" placeholder="Name" data-field="field2"
               class="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
        <input type="text" placeholder="Company" data-field="field3"
               class="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
        <button type="button" data-action="architect-form#removeRow"
                class="self-center text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4">
            <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
          </svg>
        </button>
      </div>`
  }

  _personsRowTemplate() {
    return `
      <div class="flex items-center gap-2 group" data-architect-form-target="personsRow">
        <input type="text" placeholder="Name" data-field="field1"
               class="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
        <input type="text" placeholder="Company" data-field="field2"
               class="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
        <button type="button" data-action="architect-form#removeRow"
                class="self-center text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4">
            <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
          </svg>
        </button>
      </div>`
  }
}
